import { render, staticRenderFns } from "./CosmoKiller.vue?vue&type=template&id=26dbe673&scoped=true"
import script from "./CosmoKiller.vue?vue&type=script&lang=ts"
export * from "./CosmoKiller.vue?vue&type=script&lang=ts"
import style0 from "./CosmoKiller.vue?vue&type=style&index=0&id=26dbe673&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dbe673",
  null
  
)

export default component.exports